import { AppUtils } from '../../utils/index';
/**
 * Base class for all application models.
 */
export class Application {
	private transactionkey: string;
	private register: string;

	constructor(
		register?: string | Partial<Application>,
		transactionkey = '',
	) {
		if ("string" === typeof register) {
			this.register = register;
			this.transactionkey = transactionkey;
		} else {
			AppUtils.Helper.mapObject(register, this); //NOSONAR don't care about return value
		}
	}

	get Register() {
		return this.register;
	}

	set Register(value) {
		this.register = value;
	}

	get Transactionkey(): string {
		return this.transactionkey;
	}

	set Transactionkey(value: string) {
		this.transactionkey = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * @returns true, if the application model holds valid data.
	 * 					 Returns false, if the application model is empty.
	 */
	get Valid(): boolean {
		return !!this.register;
	}


	/**
	 * Creates a new model object and copies the values from the provided data object (or other model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): Application {
		return AppUtils.Helper.createFromMap(dataObject, Application);
	}
}

